import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import getTransactionSupportInstructsService, { getInstructCategoriesService } from 'services/transactionSupport';
import {
  InstructCategoryDataTypes, InstructCategoryParamsTypes,
  TransactionSupportInstructsParams, TransactionSupportInstructsTypes,
} from 'services/transactionSupport/types';

type ProductServiceGuideState = {
  instructs?: PaginationData<TransactionSupportInstructsTypes[]>;
  instructCategory?: InstructCategoryDataTypes[];
}

const initialState: ProductServiceGuideState = {
  instructs: undefined,
  instructCategory: undefined,
};

export const getTransactionSupportInstructsAction = createAsyncThunk<
  PaginationData<TransactionSupportInstructsTypes[]>,
  TransactionSupportInstructsParams,
  { rejectValue: ErrorResponse }
>(
  'productServiceGuideReducer/getTransactionSupportInstructs',
  async (params: TransactionSupportInstructsParams, { rejectWithValue }) => {
    try {
      return await getTransactionSupportInstructsService(params);
    } catch (error) {
      return rejectWithValue(error as ErrorResponse);
    }
  },
);

export const getInstructCategoryAction = createAsyncThunk<
  InstructCategoryDataTypes[],
  InstructCategoryParamsTypes | undefined,
  { rejectValue: ErrorResponse }
>('instructCategory/getInstructCategoryAction', async (params, { rejectWithValue }) => {
  try {
    return await getInstructCategoriesService(params);
  } catch (error) {
    return rejectWithValue(error as ErrorResponse);
  }
});

const productServiceGuideSlice = createSlice({
  name: 'productServiceGuideReducer',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getTransactionSupportInstructsAction.fulfilled, ($state, action) => {
      $state.instructs = action.payload;
    });
    builder.addCase(getInstructCategoryAction.fulfilled, ($state, action) => {
      $state.instructCategory = action.payload;
    });
  },
});

export default productServiceGuideSlice.reducer;
